<div class="platforms-container" *ngIf="!!exportConfiguration">
  <div class="platforms-header">
    <h1 class="add-platform-header">{{addOrEdit}} Platform</h1>
    <label class="platform-label">LANGUAGE:</label>
    <icn-dropdown
      [short]="true"
      [selectedValue]="platformLanguage"
      (selectedValueChange)="onPlatformLanguageChanged($event)"
    >
      <icn-dropdown-item
        *ngFor="let language of languages"
        [title]="language.code"
        [value]="language.code"
      >
      </icn-dropdown-item>
    </icn-dropdown>
  </div>
  <div class="platforms-name">
    <label class="platform-label">PLATFORM NAME:</label>
    <input
      class="platform-name-input"
      placeholder="Enter Name"
      [(ngModel)]="exportConfiguration.name"
    />
  </div>
  <div class="export-platform-fields">
    <label class="export-fields-header">Choose fields to export:</label>
    <div class="wrapper">
      <div
        class="container container-left"
        [dragula]='"export-bag"'
        [(dragulaModel)]="availableHeaders"
      >
        <div *ngFor="let header of availableHeaders">
          {{formatHeader(header)}}
        </div>
      </div>
      <div
        class="container container-right"
        [dragula]='"export-bag"'
        id="export-dropzone"
        [(dragulaModel)]="exportConfiguration.headers"
      >
        <div *ngFor="let header of exportConfiguration.headers">
          {{formatHeader(header)}}
        </div>
      </div>
    </div>
  </div>
  <a class="btn btn-save" (click)="saveExportConfigurations()">Save</a>
</div>
